import z from 'zod';
import { PROJECT_CODE_SCHEMA } from '../project/project.ts';

/**
 * validation schema for response payload
 */
export const GetCustomerInfoResponseSchema = z.object({
    id: z.string(),
    orderId: z.string().uuid(),
    organizationId: z.number(),
    userId: z.number(),
    manualCostCenter: z.string().nullable(),
    constructionProjectId: z.string(),
    projectCode: PROJECT_CODE_SCHEMA,
});
